import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { updateGlobalInfo } from '@/store/user-info';
import { initLog } from '@/common/utils';
import StatusError from '@/components/status-error';
import Loadable, { LOAD_STATUS } from '@/components/loadable';
import { message } from 'antd';
import apis from '@/apis';
import { fetchDuccConfig } from '@/apis/ducc';
import _ from 'lodash';
// import CommonConfig from '@/apis/commonConfig';

// CommonConfig();
declare global {
  interface Window {
    ACORE_OSSCOOKIE: any;
  }
}

const KEY_MENULIST_CACHE = 'menuStore';
/**
 * {
 *    ACORE_OSSCOOKIE: string,
 *    res: any
 * }
 */
function getErpStorage() {
  if (!window.ACORE_OSSCOOKIE) return false;

  try {
    const menuStore = window.localStorage.getItem(KEY_MENULIST_CACHE);
    if (!menuStore) return false;

    const { ACORE_OSSCOOKIE, res } = JSON.parse(menuStore);

    if (ACORE_OSSCOOKIE === window.ACORE_OSSCOOKIE) {
      return res;
    } else {
      // 如果匹配不正确直接清空防止被二次匹配
      window.localStorage.removeItem(KEY_MENULIST_CACHE);
      return false;
    }
  } catch (ex) {
    console.error(ex);
  }

  return false;
}

// 全局的加载如果这个没有加载完成
// 没必要进入页面
function LoadFullpage(props: any): React.ReactElement {
  const [loadStatus, setLoadStatus] = useState(LOAD_STATUS.ING);
  const updateInfo = useRef(props.updateGlobalInfo);
  const loadDoneRef = useRef(props.loadDone);
  loadDoneRef.current = props.loadDone || (() => { });
  const cacheHitRef = useRef(props.cacheHit);
  cacheHitRef.current = props.cacheHit || (() => { });
  const errorMsgRef = useRef('');

  // const erpStorage = useMemo(() => {
  //   const res = getErpStorage();
  //   // 如果为真，触发缓存命中
  //   if (res) cacheHitRef.current();
  //   return res;
  // }, []);

  // useEffect(() => {
  //   if (!erpStorage) return;
  //   // 如果命中缓存暂时使用该缓存
  //   setLoadStatus(LOAD_STATUS.SUCCESS);
  //   updateInfo.current(erpStorage);
  // }, [erpStorage]);

  useEffect(() => {
    async function _fetchGlobalInfo() {
      try {
        const [res, duccConfig] = await Promise.all([
          await apis.fetchGlobalInfo(),
          await fetchDuccConfig()
            .then((res) => JSON.parse(res.data.YX_DUCC_ROUTES || '[]'))
            .catch((ex) => {
              console.error(ex);
              return [];
            }),
        ]);
        // eslint-disable-next-line
        const { systemTime, tid, ..._res } = res;
        loadDoneRef.current();

        // 未登录等待跳转登录页
        if (_res && _res.ret === '3') return;
        if (!res || _res.ret !== '0' || !Boolean(_res.data) || !Boolean(_res.data.userMap)) {
          errorMsgRef.current = _res.msg + '::::' + _res.ret;
          message.error(_res.msg);
          setLoadStatus(LOAD_STATUS.FAILED);
          return;
        }
        initLog(_res.data.userMap.erp);
        // 如果深比较相等则丢弃接口数据
        // if (_.isEqual(erpStorage, _res)) return;

        // 如果深比较不相等丢弃缓存数据
        updateInfo.current(_res, duccConfig);

        // window.ACORE_OSSCOOKIE &&
        //   window.localStorage.setItem(
        //     KEY_MENULIST_CACHE,
        //     JSON.stringify({ res: _res, ACORE_OSSCOOKIE: window.ACORE_OSSCOOKIE })
        //   );

        setLoadStatus(LOAD_STATUS.SUCCESS);
      } catch (ex: any) {
        errorMsgRef.current = ex.toString();
        console.error(ex);
        setLoadStatus(LOAD_STATUS.FAILED);
        loadDoneRef.current();
      }
    }
    _fetchGlobalInfo();
    // @ts-ignore
    // }, [erpStorage]);
  }, []);

  return (
    <Loadable
      LoadingTpl={() => <div style={{ display: 'none' }}>白屏上报，页面加载中....</div>}
      loadStatus={loadStatus}
      FailedTpl={() => (
        <StatusError
          msg={
            <div>
              网络异常，请稍后重试 <span style={{ display: 'none' }}>{errorMsgRef.current}</span>
            </div>
          }
        />
      )}
    >
      {props.children}
    </Loadable>
  );
}

export default connect(undefined, { updateGlobalInfo })(LoadFullpage);
